export default "__VITE_ASSET__Djf9E5wg__"